import { formatCurrency } from "./reportFormat";
import { DetailCards, LeaveBadges } from "./DetailCards";
import { L } from "./reportLabels";

const money = (v, c) => formatCurrency(v, c);

// تفاصيل الرواتب داخل الصفحة: بطاقات + جدول كامل بنفس أعمدة التقرير المطبوع.
export const SalaryDetails = ({ data, lang }) => {
  const labels = L[lang === "en" ? "en" : "ar"];
  const c = data.currency;
  const t = data.totals;
  return (
    <div className="grid gap-4" data-testid="salary-details">
      <DetailCards
        items={[
          [labels.cards[0], t.employees],
          [labels.cards[1], money(t.base_salary, c)],
          [labels.cards[2], money(t.accumulated, c), t.accumulated < 0 ? "bad" : "good"],
          [labels.cards[3], money(t.expected_end_of_month, c)],
        ]}
      />
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1000px] text-start text-xs">
          <thead>
            <tr className="bg-primary/10">
              {labels.cols.map((col) => (
                <th key={col} className="px-2 py-2 text-start text-[10px] font-bold text-primary">{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.employees.map((e) => (
              <tr key={e.employee_name + e.branch_name} className="border-b border-border/30"
                  data-testid={`salary-detail-row-${e.employee_name}`}>
                <td className="px-2 py-2">
                  <span className="font-bold">{e.employee_name}</span>
                  <span className="block text-[10px] text-muted-foreground">{e.branch_name}</span>
                </td>
                <td className="px-2 py-2 font-mono font-bold">{money(e.base_salary, e.currency)}</td>
                <td className="px-2 py-2 font-mono">{money(e.daily_rate, e.currency)}</td>
                <td className="px-2 py-2 font-mono">{e.days_worked}</td>
                <td className="px-2 py-2 font-mono">{e.total_weekends}/{e.paid_weekends}</td>
                <td className="px-2 py-2"><LeaveBadges breakdown={e.leave_breakdown} labels={labels.leaveTypes} /></td>
                <td className="px-2 py-2 font-mono">{e.compensation_days}</td>
                <td className="px-2 py-2 font-mono font-bold">{e.total_paid_days}</td>
                <td className={`px-2 py-2 font-mono ${e.absence_days ? "text-destructive font-bold" : ""}`}>
                  {e.absence_days}
                </td>
                <td className={`px-2 py-2 font-mono ${e.late_count ? "text-destructive font-bold" : ""}`}>
                  {e.late_count}
                </td>
                <td className="px-2 py-2 font-mono text-destructive">
                  {e.deductions_total ? `-${money(e.deductions_total, e.currency)}` : money(0, e.currency)}
                </td>
                <td className="px-2 py-2 font-mono text-destructive">
                  {e.advance_installment ? money(e.advance_installment, e.currency) : labels.none}
                </td>
                <td className={`px-2 py-2 font-mono font-black ${e.accumulated_salary < 0 ? "text-destructive" : "text-primary"}`}>
                  {money(e.accumulated_salary, e.currency)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
